var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-check 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    id: "Vector (Stroke)",
    d: "M10.7371 6.71545C10.8561 6.59646 10.8561 6.40354 10.7371 6.28455L6.71545 2.26288C6.59646 2.1439 6.40354 2.1439 6.28455 2.26288L2.26288 6.28455C2.1439 6.40354 2.1439 6.59646 2.26288 6.71545L6.28455 10.7371C6.40354 10.8561 6.59646 10.8561 6.71545 10.7371L10.7371 6.71545ZM7.4336 11.4553C6.91799 11.9709 6.08201 11.9709 5.5664 11.4553L1.54473 7.4336C1.02911 6.91799 1.02911 6.08201 1.54473 5.5664L5.5664 1.54473C6.08201 1.02911 6.91799 1.02911 7.4336 1.54473L11.4553 5.5664C11.9709 6.08201 11.9709 6.91799 11.4553 7.4336L7.4336 11.4553Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    id: "Vector (Stroke)_2",
    d: "M6.45279 8.28091L10.2752 4.45847L9.55715 3.74039L6.09375 7.2038L5.03091 6.14096C4.8326 5.94265 4.51115 5.94265 4.31284 6.14096C4.11452 6.33927 4.11452 6.66073 4.31284 6.85904L5.73471 8.28091C5.93302 8.47923 6.25448 8.47923 6.45279 8.28091Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillCheck);
export default __webpack_public_path__ + "static/media/skill-check.5334701b166b193c20df98fab0ece4df.svg";
export { ForwardRef as ReactComponent };